import React, { useEffect, useState, useRef } from 'react';
import { useIntl, FormattedNumber } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

//Components
import { Grid, Typography,Icon } from '@mui/material';
import {
  MenuComponent,
  SearchInput,
  IconButton,
  TableView,
  Tooltip,
  Pill
} from '@gpstrackit/gtc-react-controls';
import { NotificationManager } from 'Components/Notifications';

//Utils
import { getMaintenanceBar, getMaintenanceValue, getMaintenanceLabel } from '../../../../../../core/hooks/utils';
import { usePaggination } from '../../../../../../core/hooks';
import { Button } from 'Components';

//Views
import CreateEditMaintenanceService from '../../../../modals/createEditMaintenanceService';
import ScheduleMaintenanceService from '../../../../modals/scheduleMaintenanceService';
import DeleteMaintenanceService from '../../../../modals/deleteMaintenanceServiceUnit';
import EntityDetails from '../../../../modals/entityDetails';
import CompleteMaintenanceService from '../../../../modals/completeMaintenanceService';
//Styles
import styles from 'Assets/sass/core/vars.scss';
import { useDetectOutsideClick } from 'Core/hooks';

//Actions
import {
  maintenanceVVDSearchMaintenanceServiceUnits,
  maintenanceVVDExportMaintenanceServiceUnits,
  reset
} from './redux/slice';
import {
  openModalScheduleMaintenanceServiceUnit,
  openModalDeleteMaintenanceServiceUnit,
  openModalCompleteMaintenance,
  openModalEntityDetails
} from 'Redux/actions';
import { convertToKPH, formatOffsetDisplayEngineHours } from "Core/data/Helpers";
import { roundEngineHours } from '../../../../.globals/helpers';

export const ScheduledServices = (props) => {
  const { id, vehicle, showTable, view } = props;
  const { messages, locale } = useIntl();

  const pagination = usePaggination(null, null, true);

  const tableRef = useRef();
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const [openCollapsedRowsOnHover, setOpenCollapsedRowsOnHover] = useState(null);
  const [selectedItems, setSelectedItems] = useState([])
  const detectClick = useDetectOutsideClick(wrapperRef);
  useEffect(() => {
    if (!detectClick.clickInside && isNumber(openCollapsedRowsOnHover)) {
      setOpenCollapsedRowsOnHover(false);
    }
  }, [detectClick.clickInside]);

  const openDeleteMaintenanceServiceUnit = useSelector(state => state.maintenanceDeleteMaintenanceServiceUnitRedux.open);
  const openScheduleMaintenanceService = useSelector(state => state.maintenanceScheduleMaintenanceServiceRedux.open);
  const openCompleteMaintenanceService = useSelector(state => state.maintenanceCompleteMaintenanceServiceRedux.open);
  const openCreateEditMaintenanceService = useSelector(state => state.maintenanceCreateEditMaintenanceServiceRedux.open);
  const { loadingScheduledServices, scheduledServices } = useSelector(state => state.maintenanceScheduledServicesRedux);
  const openEntityDetails = useSelector(state => state.maintenanceEntityDetailsRedux.open);
  const loadingUnits = useSelector(state => state.catalogsRedux.loadingUnits)
  const user = useSelector(state => state.securityRedux.user);

  const getVehicleDisplayHours = () => {
    const fromDisplay = Number(vehicle?.displayHours);
    if (Number.isFinite(fromDisplay)) return fromDisplay;
    const fromVehicle = Number(formatOffsetDisplayEngineHours(vehicle));
    return Number.isFinite(fromVehicle) ? fromVehicle : null;
  };

  const getNextServiceEngineHours = (row) => {
    if (row?.nextServiceEngineHours != null && row?.nextServiceEngineHours !== '') {
      return Number(row.nextServiceEngineHours);
    }
    const interval = Number(row?.service?.engineHours);
    const last = row?.lastMaintenanceEngineHours;
    if (interval > 0 && last != null && last !== '') {
      return Number(last) + interval;
    }
    return null;
  };

  const canShowEngineHoursBar = (row) => {
    const last = row?.lastMaintenanceEngineHours;
    return getNextServiceEngineHours(row) != null && last != null && last !== '';
  };

  useEffect(() => {
    dispatch(maintenanceVVDSearchMaintenanceServiceUnits({ unitId: id }))
    return () => {
      dispatch(reset({ scheduledServices: [] }))
      pagination?.onChangeData([]);
    }
  }, []);

  var isNumber = function isNumber(value) {

    return typeof value == 'number';
  }

  const onCollapse = (row) => {
    let unitItems = JSON.parse(row?.items)
    if (unitItems) {
      return (
        <div style={{ padding: '16px 82px', backgroundColor: "#f7f9fc" }}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ paddingBottom: 10 }}
            wrap="nowrap"
            spacing={3}
          >
            <Grid item xs={3} zeroMinWidth className='MuiTableCell-head'>{messages['vehicleDetailView_serviceItems']}</Grid>
            <Grid item xs={3} className='MuiTableCell-head'>{messages['vehicleDetailView_laborCost']}</Grid>
            <Grid item xs={3} className='MuiTableCell-head'>{messages['vehicleDetailView_partsCost']}</Grid>
            <Grid item xs={3} className='MuiTableCell-head'>{messages['vehicleDetailView_totalCost']}</Grid>
          </Grid>

          {
            unitItems?.map((item, index) => {
              return (
                <Grid
                  key={index}
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap"
                  spacing={3}
                >
                  <Grid item xs={3} zeroMinWidth>
                    <Typography noWrap>{item?.name}</Typography>
                  </Grid>
                  <Grid item xs={3}><FormattedNumber value={item.labor} style="currency" currency="USD" /></Grid>
                  <Grid item xs={3}><FormattedNumber value={item.parts} style="currency" currency="USD" /></Grid>
                  <Grid item xs={3}><FormattedNumber value={item.parts + item.labor} style="currency" currency="USD" /></Grid>
                </Grid>
              )
            })
          }
        </div>
      )
    }
  }

  useEffect(() => {
    pagination.setColumns([
      {
        key: 'service.title',
        title: messages['scheduleDriverTask_service'],
        show: true,
        width: 200,
        sort: true,
        export: true,
        sortValue: (row) => row?.service?.title,
        exportValue: (row) => row?.service?.title,
        render: (row) => {
          return (
            <Grid container alignItems="center">
              <Grid item xs={9}>
                {row?.service?.title?.length > 30 ? (
                  <Tooltip title={row?.service?.title}>
                    <span className="txtTitleService">{row?.service?.title}</span>
                  </Tooltip>
                ) : (
                  <span className="txtTitleService">{row?.service?.title}</span>
                )}
              </Grid>
              <Grid item xs={3}>
                {
                  (row && !row.completed)
                  &&
                  <MenuComponent
                    options={[messages['complete'], messages['edit'], messages['vehicleDetailView_exportTask'], messages['delete']]}
                    icon="more_vert"
                    className="showInHover"
                    onClick={handleClickMenu}
                    value={row}
                    disabled={loadingScheduledServices || loadingUnits}
                  />
                }
              </Grid>

            </Grid>
          )
        }
      },
      {
        key: 'miles',
        title: user.isKph ? messages['kilometers'] : messages['vehicleDetailView_miles'],
        show: true,
        width: 150,
        sort: true,
        export: true,
        sortValue: (row) => {
          if (!row?.service?.miles || !vehicle) {
            return 0;
          }
          const percentage = getMaintenanceValue("odometer", row.lastMaintenanceOdometer, row.nextServiceOdometer, vehicle?.displayOdometer || 0)
          return percentage;
        },
        exportValue: (row) => {
          if (!row?.service?.miles || !vehicle) {
            return null;
          }
          let miles = getMaintenanceLabel("odometer", row.lastMaintenanceOdometer, row.nextServiceOdometer, vehicle?.displayOdometer || 0, messages)
          return miles
        },
        render: (row) => {
          if (!row?.service?.miles || !vehicle) {
            return <span />;
          }
          if (row?.nextServiceOdometer &&  !parseFloat(vehicle?.ecuEngineOdometer)  && !parseFloat(vehicle?.engineOdometer) && !parseInt(vehicle?.displayOdometer)) {
            return   (<Tooltip title={messages['vehicleDetailView_warningNotInfoOdometer']} >
                        <Icon style={{ cursor: "pointer", color: '#ffc107',marginLeft:"calc(50% - 12px)" }}>warning</Icon>
                    </Tooltip> )
          }

          return (
            <>
              {
                getMaintenanceBar("odometer", row.status, user.isKph ? convertToKPH(row.lastMaintenanceOdometer) : row.lastMaintenanceOdometer, user.isKph ? convertToKPH(row.nextServiceOdometer) : row.nextServiceOdometer, user.isKph ? convertToKPH(vehicle?.displayOdometer || 0) : vehicle?.displayOdometer || 0, messages,null,{...row,...vehicle},user)
              }
            </>
          )
        },
      },
      {
        key: 'days',
        title: messages['vehicleDetailView_days'],
        show: true,
        width: 150,
        export: true,
        sortValue: (row) => {
          if (!row?.service?.days || !row.nextServiceDate) {
            return 0;
          }
          const percentage = getMaintenanceValue("time", row.lastMaintenanceDate, row.nextServiceDate, moment());
          return percentage;
        },
        exportValue: (row) => {
          let days = ""
          if (row?.service?.days && vehicle) {
            days = getMaintenanceLabel("time", row.lastMaintenanceDate, row.nextServiceDate, moment(), messages)
          }
          return days;
        },
        render: (row) => {
          
          if (row?.service?.days && !row?.nextServiceDate) {
            return   (<Tooltip title={`${messages['vehicleDetailView_warningNotNextDate']}`} >
                        <Icon style={{ cursor: "pointer", color: '#ffc107',marginLeft:"calc(50% - 12px)" }}>warning</Icon>
                    </Tooltip> )
          }

          if (!row?.service?.days || !row.nextServiceDate) {
            return 0;
          }

          return (
            <>
              {
                getMaintenanceBar("time", row.status, row.lastMaintenanceDate, row.nextServiceDate, moment(), messages,null,{...row,...vehicle})
              }
            </>
          )
        }
      },
      {
        key: 'hours',
        title: messages['vehicleDetailView_engineHours'],
        show: true,
        width: 150,
        export: true,
        sortValue: (row) => {
          if (!vehicle || !canShowEngineHoursBar(row)) return 0;
          const currentHours = getVehicleDisplayHours() || 0;
          return getMaintenanceValue("engineHours", row.lastMaintenanceEngineHours, getNextServiceEngineHours(row), currentHours);
        },
        exportValue: (row) => {
          if (!vehicle || !canShowEngineHoursBar(row)) return "";
          const currentHours = getVehicleDisplayHours() || 0;
          return getMaintenanceLabel("engineHours", row.lastMaintenanceEngineHours, getNextServiceEngineHours(row), currentHours, messages);
        },
        render: (row) => {
          if (!vehicle) {
            return <span />;
          }

          if (!canShowEngineHoursBar(row)) {
            const last = row?.lastMaintenanceEngineHours;
            if (last != null && last !== '') {
              return <span>{roundEngineHours(last)}</span>;
            }
            return <span />;
          }

          const currentHours = getVehicleDisplayHours();
          if (currentHours == null) {
            return (
              <Tooltip title={messages['vehicleDetailView_warningNotInfoEngineHour']}>
                <Icon style={{ cursor: "pointer", color: '#ffc107', marginLeft: "calc(50% - 12px)" }}>warning</Icon>
              </Tooltip>
            );
          }

          return getMaintenanceBar(
            "engineHours",
            row.status,
            row.lastMaintenanceEngineHours,
            getNextServiceEngineHours(row),
            currentHours,
            messages,
            null,
            { ...row, ...vehicle },
            user
          );
        }
      },
      {
        key: 'cost',
        title: messages['vehicleDetailView_cost'],
        show: true,
        width: 100,
        sort: true,
        export: true,
        sortValue: (row) => {
          const format = { style: 'currency', currency: 'USD' };
          const numberFormat = Intl.NumberFormat('en-US', format);
          return numberFormat.format(Math.abs(row?.estimatedCost));
        },
        exportValue: (row) => {
          const format = { style: 'currency', currency: 'USD' };
          const numberFormat = new Intl.NumberFormat('en-US', format);
          return numberFormat.format(Math.abs(row?.estimatedCost));
        },
        render: (row) => {
          // let cost = row && row.estimatedCost ? row.estimatedCost : 0;
          let getCoast = 0
          const parseFormat = JSON.parse(row?.items)
          parseFormat?.map(item => getCoast += item?.subtotal)
          return (<FormattedNumber value={getCoast} style="currency" currency="USD" />)
        }
      },
      {
        key: 'status',
        title: messages['vehicleDetailView_status'],
        show: true,
        width: 100,
        sort: true,
        export: true,
        sortValue: (row) => row?.status || "",
        exportValue: (row) => row?.status || "",
        render: (row) => {
          if (!row.status) {
            return <span />;
          }

          let color = '';
          let tooltip = '';

          if (row.status === 'Completed') {
            color = styles.black;
            tooltip = messages['vehicleDetailView_completedStatus'];
          } else if (row.status === 'Due') {
            color = styles.red;
            tooltip = messages['vehicleDetailView_dueStatus'];
          } else if (row.status === 'PastDue') {
            color = styles.purple;
            tooltip = messages['pastDue'];
          } else if (row.status === 'DueSoon') {
            color = styles.orange;
            tooltip = messages['vehicleDetailView_dueSoonStatus'];
          } else if (row.status === 'DueNow') {
            color = styles.orange;
            tooltip = messages['vehicleDetailView_dueSoonStatus'];
          } else if (row.status === 'Scheduled') {
            color = styles.green;
            tooltip = messages['vehicleDetailView_scheduledStatus'];
          } else if (row.status === 'Done') {
            color = styles.black;
            tooltip = messages['done'];
          }

          return (
            <Pill style={{ width: 110 }} item={{ label: tooltip, color: color }} />
          );
        }
      },
      {
        key: 'subscribers',
        title: messages['vehicleDetailView_subscribers'],
        show: true,
        width: 100,
        sort: true,
        export: true,
        sortValue: (row) => row && row.subscribersCount ? row.subscribersCount : 0,
        exportValue: (row) => row?.subscribersCount || 0,
        render: (row) => {
          return (
            <>
              {
                row.subscribersCount > 0 &&
                <IconButton
                  placement="bottom"
                  variant="secondary"
                  icon="people"
                  size="small"
                  disabled={loadingScheduledServices || loadingUnits}
                  onClick={() => handleDetails(row.id, 'MaintenanceServiceUnit', 0, row.service.title)}
                />
              }
            </>
          )
        }
      },
      {
        key: 'attachments',
        title: messages['vehicleDetailView_attachments'],
        show: true,
        width: 100,
        sort: true,
        export: true,
        sortValue: (row) => row && row.fileIds ? row.fileIds.length : 0,
        exportValue: (service) => service?.fileIds?.length,
        render: (row) => {
          return (
            <>
              {
                (row.fileIds && row.fileIds.length > 0) &&
                <IconButton
                  placement="bottom"
                  variant="secondary"
                  icon="attach_file"
                  size="small"
                  disabled={loadingScheduledServices || loadingUnits}
                  onClick={() => handleDetails(row.id, 'MaintenanceServiceUnit', 2, row.service.title)}
                />
              }
            </>
          )
        }
      },
      {
        key: 'notes',
        title: messages['vehicleDetailView_notes'],
        show: true,
        width: 150,
        sort: true,
        export: true,
        sortValue: (row) => row?.notes || "",
        render: (row) => {
          if (!row.notes) return <div />
          return (
            <div
              style={{ width: 150, cursor: 'pointer' }}
              onClick={() => handleDetails(row.id, 'MaintenanceServiceUnit', 1, row.service.title)}
            >
              <Tooltip
                placement="bottom"
                title={row.notes}
              >
                <Grid container wrap="nowrap">
                  <Grid item xs zeroMinWidth>
                    <Typography noWrap>
                      {row.notes}
                    </Typography>
                  </Grid>
                </Grid>
              </Tooltip>
            </div>
          )
        }
      }
    ]);
  }, [locale, vehicle, user]);

  useEffect(() => {
    if (scheduledServices && vehicle) {
      try {
        let data = scheduledServices ? scheduledServices.map(service => {
          let items = service?.items ? JSON.parse(service?.items) : []
          return { ...service, children: items?.length ? 1 : 0 }
        }) : []
        pagination.onChangeData(data);
      } catch (error) {
        pagination.onChangeData([]);
      }
    }
  }, [scheduledServices, vehicle])


  const handleClickMenu = (type, serviceUnit) => {
    if (type === messages['complete']) {
      dispatch(openModalCompleteMaintenance({ open: true, serviceUnitId: serviceUnit.id }))
    } else if (type === messages['edit']) {
      dispatch(openModalScheduleMaintenanceServiceUnit({ open: true, id: serviceUnit.id }))
    }
    else if (type === messages['vehicleDetailView_exportTask']) {

      let services = JSON.stringify({ service: serviceUnit?.serviceId, serviceLogId: serviceUnit?.id, displayOdometer: vehicle?.displayOdometer, displayHours: vehicle?.displayHours })
      dispatch(maintenanceVVDExportMaintenanceServiceUnits({ services: [services], serviceType: 'SCHEDULE', units: [{ "id": serviceUnit?.unitId, "type": "Unit" }] }))

      NotificationManager.success(
        messages['vehicleDetailView_exportGenerated'],
        messages['success'],
        3000,
        null,
        null,
        'Success',
      );
    } else if (type === messages['delete']) {
      dispatch(openModalDeleteMaintenanceServiceUnit({ open: true, service: serviceUnit }))
    }
  };

  const handleDetails = (entityId, entityName, numberTab, title) => {
    dispatch(openModalEntityDetails({ open: true, entityId, entityName, numberTab, title }))
  };

  const refreshTable = () => {
    dispatch(maintenanceVVDSearchMaintenanceServiceUnits({ unitId: id }))
  }

  return (
    <Grid item container style={{ marginTop: 15 }}>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Grid item xs={6} sm={4}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item style={{ display: 'flex' }}>
              <IconButton
                tooltip={messages["add"]}
                placement="bottom"
                variant="secondary"
                icon="add_box"
                size="small"
                isDisabled={loadingScheduledServices || loadingUnits}
                onClick={() => {
                  dispatch(openModalScheduleMaintenanceServiceUnit({ open: true }))
                }}
              />

              <Button
                tooltip={messages["vehicleDetailView_exportTask"]}
                icon="get_app"
                type="icon"
                disabled={!selectedItems?.length}
                onClick={(type) => {
                  let services = selectedItems.map((su) => (JSON.stringify({
                    service: su.serviceId,
                    serviceLogId: su.id,
                    displayOdometer: vehicle?.displayOdometer,
                    displayHours: vehicle?.displayHours,
                  })));
                  dispatch(maintenanceVVDExportMaintenanceServiceUnits({ services, serviceType: 'SCHEDULE', units: [{ "id": id, "type": "Unit" }] }))
                  NotificationManager.success(
                    messages['vehicleDetailView_exportGenerated'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'Success',
                  );
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4} style={{ display: 'flex' }}>
          <Pill
            item={{ id: 1, label: messages['vehicleDetailView_scheduledList'], color: view === "scheduled" ? styles.blue_gtc : styles.lightGray }}
            onClick={() => showTable('scheduled')}
          />
          <Pill
            item={{ id: 1, label: messages['vehicleDetailView_performedList'], color: view === "performed" ? styles.blue_gtc : styles.lightGray }}
            onClick={() => showTable('performed')}
          />
        </Grid>
        <Grid item xs={12} sm={4} className="mb-10 text-right">
          <SearchInput
            placeholder={messages['search']}
            searchText={pagination.searchText}
            onSearchText={pagination.onSearchChange}
          />
        </Grid>
      </Grid>
      <TableView
        ref={tableRef}
        {...pagination}
        keyColumn="serviceId"
        loading={loadingScheduledServices || loadingUnits}
        topheight={285}
        hideDragable
        hideAllInPagination
        onCollapse={onCollapse}
        onSelectedItems={(items) => setSelectedItems(items)}
      />
      {openScheduleMaintenanceService &&
        <ScheduleMaintenanceService
          vehicle={vehicle}
          refresh={() => refreshTable()}
        />}
      {openDeleteMaintenanceServiceUnit && <DeleteMaintenanceService refresh={() => refreshTable()} />}
      {openEntityDetails && <EntityDetails refresh={() => refreshTable()} />}
      {openCompleteMaintenanceService && <CompleteMaintenanceService vehicle={vehicle} refresh={() => refreshTable()} />}
      {openCreateEditMaintenanceService && <CreateEditMaintenanceService />}
    </Grid>
  );
};

export default ScheduledServices;
